import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { PlanPackagePage } from "src/routes/libraries/plan-package/details/PlanPackagePage";
import { PlanPackagesPage } from "src/routes/libraries/plan-package/list/PlanPackagesPage";
import { PlanPackageTakeoffPage } from "src/routes/libraries/plan-package/takeoffs/PlanPackageTakeoffPage";
import { PlanPackageTakeoffSideNavLayout } from "src/routes/libraries/plan-package/takeoffs/PlanPackageTakeoffSideNavLayout";
import { ReviewSlotRequestsPage } from "src/routes/libraries/plan-package/takeoffs/components/SlotReview/ReviewSlotRequestsPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as planPaths from "src/routing/domains/libraries/plan/planPaths";

/**
 * Legacy `/libraries/plan/*` route tree (list, takeoffs, and the legacy details redirect).
 *
 * Role: data router domain route.
 *
 * Two layout stacks coexist during migration:
 * - **New (Beam):** `AppShell` → `BeamNavbarLayout` → page (list using `PageHeaderLayout`)
 * - **Legacy:** `AppShell` → `GlobalNavLayout` → page (details/takeoffs not yet on Beam nav)
 *
 * The details route only redirects legacy links (still emitted by the backend) to the `/libraries/plan-packages/*` page.
 */
export const planRoutes: RouteObject = {
  path: planPaths.planListRoute.path,
  Component: AppShell,
  children: [
    { Component: BeamNavbarLayout, children: [{ index: true, Component: PlanPackagesPage }] },
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [{ path: `${planPaths.planDetailsRoute.path}/*`, Component: PlanPackagePage }],
        },
        {
          Component: PlanPackageTakeoffSideNavLayout,
          children: [{ path: planPaths.planTakeoffsRoute.path, Component: PlanPackageTakeoffPage }],
        },
        { path: planPaths.planIncomingSlotReviewRoute.path, Component: ReviewSlotRequestsPage },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
